import { defineMessages } from 'react-intl';

export const THRESHOLD = defineMessages({
  dynamic: {
    id: 'WgyyLcd/Xq9voOe4',
    defaultMessage: 'Dynamic',
    description: 'Message to display when a threshold is dynamic',
  },
});
